// utils/deviceDetect.js
import MobileDetect from 'mobile-detect';

export function getDeviceType() {
  const md = new MobileDetect(window.navigator.userAgent);
  if (md.tablet()) {
    return 'tablet';
  } else if (md.mobile()) {
    return 'mobile';
  } else {
    return 'desktop';
  }
}
